export const maxWidth = 486;
export const SPECIAL_CHAR_REGEX =/[\w\^]/; // 匹配特殊字符
